import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';

import LoadingIndicator from '../../components/loading-indicator/loading';

import FacilitiesService from '../../api/services/FacilitiesService';
import { loadProjects } from '../../redux/actions/projectActions';
import Dropdown from '../../components/data-dropdown/dropdown';

function Warehouse({
    projects,
    loadProjects
}) {
    const [projectId, setProjectId] = useState(0);
    const [sourceFacilityId, setSourceFacilityId] = useState(0);
    const [destinationFacilityId, setDestinationFacilityId] = useState(0);
    const [sourceFacilities, setSourceFacilities] = useState([]);
    const [destinationFacilities, setDestinationFacilities] = useState([]);
    const [destinationDisabled, setDestinationDisabled] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const previousProjectId = useRef(0);
    const previousSourceFacilityId = useRef(0);
    
    useEffect(() => {
        loadProjects(sourceFacilityId).catch(error => {
            alert('Loading projects failed: ' + error)
        });
    }, []);

    useEffect(() => { 
        const setFacilities = async () => {
            var sourceFacilities = [];
            var destinationFacilities = [];
            
            await FacilitiesService.getFacilities(projectId).then(response => {
                sourceFacilities = response;
            }).catch(error => {
                alert('Loading destination facilities failed: ' + error)
            })
            
            if (projectId > 0) {
                await FacilitiesService.getFacilities('').then(response => {
                    destinationFacilities = response;
                }).catch(error => {
                    alert('Loading destination facilities failed: ' + error)
                })

                if (projectId !== previousProjectId.current) {
                    previousProjectId.current = projectId;
                    previousSourceFacilityId.current = sourceFacilities[0].id;
                    setSourceFacilityId(sourceFacilities[0].id)
                    setDestinationFacilities(destinationFacilities.filter(x => x.id !== sourceFacilities[0].id));
                    setDestinationDisabled(false)
                } else {
                    previousProjectId.current = projectId;
                    previousSourceFacilityId.current = sourceFacilityId;
                    setDestinationFacilities(destinationFacilities.filter(x => x.id !== sourceFacilityId));
                    setDestinationDisabled(false)
                }
                
            } else {
                setDestinationDisabled(true)
            }
           
            setSourceFacilities(sourceFacilities);
        }

        setFacilities();
    }, [projectId, sourceFacilityId]);
    
    const projectHandleChange = (event) => {
        setProjectId(event.target.value);
    };

    const sourceFacilityHandleChange = (event) => {
        setSourceFacilityId(event.target.value);
    };

    const destinationFacilityHandleChange = (event) => {
        setDestinationFacilityId(event.target.value);
    };

    const validate = () => {
        const errors = [];

        if (projectId === '') {
            errors.push('A project selection is required.');
        }

        if (sourceFacilityId === '' || destinationFacilityId === '') {
            errors.push('A source and destination facility are required.');
        }

        if (sourceFacilityId == destinationFacilityId) {
            errors.push('Destination cannot be the same as the source.');
        }

        return errors;
    }

    const reset = () => {
        setProjectId('');
        setSourceFacilityId('');
        setDestinationFacilityId('');
    }

    function onSubmitTransfer(event) {
        event.preventDefault();

        const validationErrors = validate();
        if (validationErrors.length > 0) {
            toast.error(validationErrors.join(' \n'))
            return;
        }

        setIsProcessing(true);
        FacilitiesService.transferFacilities(projectId, sourceFacilityId, destinationFacilityId)
            .then(response => {
                setIsProcessing(false);
                toast.success(`${response.itemsTransferred} items have been transferred to the destination project.`);
                reset();
            })
            .catch(error => {
                setIsProcessing(false);
                toast.error('There was an error transferring the items: ' + error);
            })
    }
    return (
        <div>
            <section className="dashboard card">                
                <article>
                    <h1>Transfer Warehouse</h1>

                    <form>
                        <Dropdown 
                            name="Project"
                            currentValue={projectId}
                            handleChange={projectHandleChange}
                            data={projects}
                        ></Dropdown>

                        <Dropdown 
                            name="Source Warehouse"
                            currentValue={sourceFacilityId}
                            handleChange={sourceFacilityHandleChange}
                            data={sourceFacilities}
                        ></Dropdown>

                        <Dropdown 
                            name="Destination Warehouse"
                            disable={destinationDisabled}
                            currentValue={destinationFacilityId}
                            handleChange={destinationFacilityHandleChange}
                            data={destinationFacilities}
                        ></Dropdown>
                    </form>

                    <br /><br />
                    <Alert severity="info">
                        The transfer process may take a few minutes to complete, depending on the number of items to transfer.
                        Please do not navigate away from this page while the process is running.
                    </Alert>
                    <br /><br />

                    <Button type="submit" variant="contained" color="primary" onClick={onSubmitTransfer} disabled={isProcessing}>
                        Transfer
                    </Button>
                    
                    <LoadingIndicator visible={isProcessing} />
                </article>
            </section>
        </div>
    )
}

Warehouse.propTypes = {
    projects: PropTypes.array.isRequired,
    loadProjects: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        projects: state.projects
    }
}

const mapDispatchToProps = {
    loadProjects
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Warehouse);